module.exports = __webpack_public_path__ + "img/usage_port.ea3c7dd2.png";